export const SET_CAPTCHA_RESPONSE = 'SET_CAPTCHA_RESPONSE';
export const SET_CAPTCHA_VERIFICATION_ERROR = 'SET_CAPTCHA_VERIFICATION_ERROR';
export const HCAPTCHA_CN_API_HOST = 'https://cn1.hcaptcha.com';
export const HCAPTCHA_CN_ENDPOINT = 'https://cn1.hcaptcha.com';
export const HCAPTCHA_CN_ASSET_HOST = 'https://assets-cn1.hcaptcha.com';
export const HCAPTCHA_CN_IMG_HOST = 'https://imgs-cn1.hcaptcha.com';
export const HCAPTCHA_CN_REPORT_API = 'https://reportapi-cn1.hcaptcha.com';
